import React from 'react';

import { observer } from 'mobx-react';
import { enqueueSnackbar } from 'notistack';

import classes from './UploadRegistrationLogoModal.module.scss';
import { UploadImageModal } from '../../../../../../shared/components/modals';
import { HeaderBar } from '../../../../../../shared/components/header-components/HeaderBar/HeaderBar';
import { CompanySubLogo } from '../../../../../../shared/components/header-components/CompanySubLogo/CompanySubLogo';
import { registrationFormLogoService } from '../../../../../services/registrationFormLogoService';
import { uploadFileTypes } from '../../../../../../shared/constants/uploadFileTypes';
import { fileService } from '../../../../../../shared/services/fileService';
import { LoadedFile } from '../../../../../../shared/interfaces/LoadedFile';

type UploadRegistrationLogoModalProps = {
  entityId: number;
  onClose: () => void;
};

const UploadRegistrationLogoModal = observer(
  ({ entityId, onClose }: UploadRegistrationLogoModalProps) => {
    const getImage = async () => {
      const logo = await registrationFormLogoService.getCompanyLogo(entityId, {
        isRunGlobalSpinner: false,
      });

      return logo;
    };

    const uploadImage = async (file: File) => {
      const logo = await fileService.uploadFile(uploadFileTypes.ENTITY_LOGO, file, {
        isRunGlobalSpinner: false,
      });

      return logo;
    };

    const removeImage = async () => {
      await registrationFormLogoService.deleteCompanyLogo(entityId);

      enqueueSnackbar('The logo is deleted', {
        variant: 'success',
        autoHideDuration: 5000,
      });
    };

    const saveImage = async (logo: LoadedFile) => {
      await registrationFormLogoService.setCompanyLogo(entityId, logo.id);

      enqueueSnackbar('The logo is uploaded and saved successfully', {
        variant: 'success',
        autoHideDuration: 5000,
      });
    };

    return (
      <UploadImageModal
        open
        title="Upload Business Logo"
        description="The logo of your business will be placed next to the LifeBase logo in the header of the user registration form. Please ensure that your logo looks good against a dark background."
        renderPreview={(logoUrl) => (
          <HeaderBar className={classes.headerBar}>
            <CompanySubLogo logoUrl={logoUrl} />
          </HeaderBar>
        )}
        onClose={onClose}
        getImage={getImage}
        uploadImage={uploadImage}
        removeImage={removeImage}
        saveImage={saveImage}
      />
    );
  },
);

export { UploadRegistrationLogoModal };
